import { ReactNode } from "react";
import "./ActorPresetRow.css";

/** One row of the actor preset sheet: label column on the left, control on the right, spacing between rows. */
export default function ActorPresetRow(props: {
  children: ReactNode;
  name: string;
  /** Quiet second line under the label, e.g. "Only shown in Creator". */
  hint?: string;
  testId?: string;
}) {
  const { name, hint, children, testId } = props;

  return (
    <div className="actorpreseteditor-row" data-testid={testId}>
      <div className="actorpreseteditor-row-label">
        <span>{name}</span>
        {hint && <span className="actorpreseteditor-row-hint">{hint}</span>}
      </div>
      <div className="actorpreseteditor-row-control">{children}</div>
    </div>
  );
}
